module.exports = __webpack_public_path__ + "static/media/IMG_1887.e3c161bd.JPG";